export class GetContributionChartRequest {
  ProductId: number;
}
